<bzg-modal-header>
  <span class="bzg-modal__header">{{'ENVIRONMENT.ADD_NEW_PROPERTY' | translate}}</span>
</bzg-modal-header>
<bzg-modal-content>
  <bzg-input [(ngModel)]="name" [placeholder]="'ENVIRONMENT.TYPE_NAME' | translate" class="margin_bottom" required>
    {{'ENVIRONMENT.COLUMN_NAME' | translate}}
    <bzg-required-error>{{'ENVIRONMENT.ERROR_NAME' | translate}}</bzg-required-error>
  </bzg-input>
  <bzg-input [(ngModel)]="value" [placeholder]="'ENVIRONMENT.TYPE_VALUE' | translate" class="margin_bottom" required>
    {{'ENVIRONMENT.COLUMN_VALUE' | translate}}
    <bzg-required-error>{{'ENVIRONMENT.ERROR_VALUE' | translate}}</bzg-required-error>
  </bzg-input>
  <bzg-textarea [(ngModel)]="description" [placeholder]="'ENVIRONMENT.TYPE_DESCRIPTION' | translate" required>
    {{'ENVIRONMENT.COLUMN_DESCRIPTION' | translate}}
    <bzg-required-error>{{'ENVIRONMENT.ERROR_DESCRIPTION' | translate}}</bzg-required-error>
  </bzg-textarea>
</bzg-modal-content>
<bzg-modal-footer class="modal-property-footer">
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m" class="btn-cancel-modal">{{'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="ok()" [disabled]="btnDisabled()">{{'GLOBAL.ADD' | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
